import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {OrderDetailsService} from './../shared/services/order-details/order-details.service';
import {LoginService} from './../shared/services/login/login.service';
import {Order} from '../shared/contracts/order';
import {AutofillEligibilityService} from '../shared/services/autofill-eligibility/autofill-eligibility.service';
import {localConsole} from '../shared/utils/local-console';

export interface OrdersSummery {
  noOrders: boolean;
  allOrders: Order[];
  nextOrders: Order[];
  orderHistory: Order[];
}

@Injectable({
  providedIn: 'root'
})
export class AutofillEligibilityResolver implements Resolve<any> {
  constructor(private _order: OrderDetailsService,
              private _autofillEligibilty: AutofillEligibilityService,
              private _auth: LoginService) {
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | any {
    const user = this._auth.userData || {};
    // 06/04/2020: added isApprovalRequired check on autofillEligibility check
    // TODO: refactor checks for eligiblity checks
    if (user.authenticated && user.rxTied && this._order.dynamicDashboard &&
      this._autofillEligibilty.autofillEnabled && this._order.asyncOrderDetails) {
      this._order.asyncOrderDetails.subscribe(data => {
        if (this._order.approvalRequired) {
          this.setEligiblityDefaults(false);
        }
        if (this._order.isAutoFillEnrolled) {
          // If already autofill enrolled, use eligibility service
          // subject to notify header and tabs to show/hide necessary
          // features
          this.setEligiblityDefaults(this._order.isAutoFillEnrolled);
        }
        const currentBox = this._order.currentBox();
        if (currentBox && !this._order.isAutoFillEnrolled && this._order.shouldCheckEligibility(currentBox)) {
          if (!this._autofillEligibilty.pendingDetermination) {
            return this._autofillEligibilty.getAutofillEligibility(currentBox, user).subscribe(res => {
              return res;
            }, err => err);
          }
        }
      }, err => {
        localConsole.log(err);
        return err;
      });
    } else {
      // set default false if all conditions are failed
      this.setEligiblityDefaults(false);
    }
    return true;
  }

  setEligiblityDefaults(autofillEnrolled: boolean): any {
    const status = {
      autofillEnrolled: autofillEnrolled,
      autofillEligible: false
    };
    this._autofillEligibilty.asyncSDEligibility.next(status);
    return status;
  }
}
